import { Controller } from "@hotwired/stimulus"

let crmYearReportChart;
let crmYearReportDatatable;
let crmYearTableFixedHeader;

export default class extends Controller {
  static values = { pageLength: Number }

  connect() {
    crmYearReportChart = echarts.init(document.getElementById('crm-year-report-chart'));

    const xAxis = JSON.parse(this.data.get("x_axis"));
    const top20s = JSON.parse(this.data.get("top20s"));
    const top20to50 = JSON.parse(this.data.get("top20to50s"));
    const gt50s = JSON.parse(this.data.get("gt50s"));
    const others = JSON.parse(this.data.get("others"));

    const option = {
      legend: {
        data: ['TOP 20 房企','TOP 20-50 房企','非 TOP 50 大客户','其他'],
        align: 'left'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      grid: {
        left: 65,
        right: 0,
        top: 48,
        bottom: 60
      },
      toolbox: {
        feature: {
          dataView: {},
          saveAsImage: {
              pixelRatio: 2
          }
        }
      },
      xAxis: {
        data: xAxis,
        silent: true,
        axisLabel: {
          interval: 0,
          fontSize: 14
        },
        splitLine: {
          show: false
        }
      },
      yAxis: [{
        type: 'value',
        position: 'left',
        axisLabel: {
          formatter: '{value}百万'
        }
      }],
      series: [{
        name: 'TOP 20 房企',
        type: 'bar',
        stack: '生产合同额',
        data: top20s,
        barMaxWidth: 68,
        label: {
          show: true,
          position: 'inside'
        }
      },{
        name: 'TOP 20-50 房企',
        type: 'bar',
        stack: '生产合同额',
        data: top20to50,
        barMaxWidth: 68,
        label: {
          show: true,
          position: 'inside'
        }
      },{
        name: '非 TOP 50 大客户',
        type: 'bar',
        stack: '生产合同额',
        data: gt50s,
        barMaxWidth: 68,
        label: {
          show: true,
          position: 'inside'
        }
      },{
        name: '其他',
        type: 'bar',
        stack: '生产合同额',
        data: others,
        barMaxWidth: 68,
        label: {
          show: true,
          position: 'inside'
        }
      }]
    };

    function drill_down_crm_year_chart_detail(params) {
      if (params.componentType === 'series') {
        if (params.seriesType === 'bar') {
          const series_name = params.seriesName;
          const sent_data = { year: params.name, series_name };

          const drill_down_url = "/report/crm_year_report/drill_down";

          if(series_name != '其他') {
            $.ajax(drill_down_url, {
              data: sent_data,
              dataType: 'script'
            });
          }
        }
      }
    }
    crmYearReportChart.setOption(option, false);
    crmYearReportChart.on('click', drill_down_crm_year_chart_detail);

    setTimeout(() => {
      crmYearReportChart.resize();
    }, 200);

    const normalColumns = [
      {"data": "rank", bSortable: false},
      {"data": "customer_group", bSortable: false},
      {"data": "kerrey_trading_area_ranking"},
      {"data": "customer_ownership", bSortable: false},
      {"data": "production_contract_value_last_year"},
      {"data": "production_contract_value_this_year"},
      {"data": "production_contract_value_this_year_last_year_delta", bSortable: false},
      {"data": "group_production_contract_value_last_year"},
      {"data": "group_production_contract_value_this_year"},

      {"data": "scheme_production_contract_value_at_each_stage"},
      {"data": "construction_drawing_production_contract_value_at_each_stage"},
      {"data": "whole_process_production_contract_value_at_each_stage"},
      {"data": "other_contract_value_at_each_stage", bSortable: false},
      {"data": "total_contract_value_of_the_group_percent"},
      {"data": "the_top_three_teams_in_cooperation", bSortable: false},

      {"data": "average_contract_value_of_single_project_in_the_past_year", bSortable: false},
      {"data": "average_scale_of_single_project_in_the_past_year", bSortable: false},
      {"data": "nearly_one_year_contract_average_contract_period", bSortable: false},
      {"data": "proportion_of_contract_amount_modification_fee", bSortable: false},
      {"data": "proportion_of_labor_cost_of_bidding_land_acquisition", bSortable: false},
    ];

    crmYearReportDatatable = $('#crm-year-report-datatable').DataTable({
      "processing": true,
      "serverSide": true,
      "pageLength": this.pageLengthValue,
      "autoWidth": false,
      "ajax": {
        "url": $('#crm-year-report-datatable').data('source'),
        "type": "POST",
      },
      "pagingType": "full_numbers",
      "columns": normalColumns,
      "dom":
        "<'text-end'<'d-inline-block'B><'d-inline-block ms-5'l>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      "order": [[ 5, 'desc' ]],
      stateSave: true,
      stateSaveCallback: function(settings, data) {
          localStorage.setItem('DataTables_crm_year_report', JSON.stringify(data));
        },
      stateLoadCallback: function(settings) {
        return JSON.parse(localStorage.getItem('DataTables_crm_year_report'));
        }
    });

    function draw_dt() {
      const pageInfo = crmYearReportDatatable.page.info();
      crmYearReportDatatable.column(0, { page: 'current' }).nodes().each(function (cell, i) {
        cell.innerHTML = i + 1 + pageInfo.start;
      });
    }
    crmYearReportDatatable.on('draw.dt', draw_dt);

    crmYearTableFixedHeader = new $.fn.dataTable.FixedHeader(crmYearReportDatatable, {
      header: true,
      footer: false,
      headerOffset: 50,
      footerOffset: 0
    });
  }

  layout() {
    crmYearReportChart.resize();
  }

  disconnect() {
    crmYearReportChart.dispose();
    crmYearTableFixedHeader.destroy();
    crmYearReportDatatable.destroy();
  }
}
